import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function LegalLayout({ title, intro, lastUpdated, children, testid }) {
  // M917 — title/canonical/robots are now managed by the <SEO/> component
  // mounted by each legal page (PrivacyPolicy / CookiePolicy / TermsConditions).
  // LegalLayout stays purely presentational.

  return (
    <div className="min-h-screen bg-[#F5F6F6]" data-testid={testid}>
      <Header />
      <main className="max-w-3xl mx-auto px-6 lg:px-8 py-14">
        <nav className="text-sm text-[#6B7280] mb-6">
          <Link to="/" className="hover:text-[#965EA7]">Acasă</Link>
          <span className="mx-2">/</span>
          <span>{title}</span>
        </nav>

        <h1 className="font-display text-3xl md:text-5xl font-bold text-[#373A45]">
          {title}
        </h1>
        {lastUpdated && (
          <div className="mt-3 text-sm text-[#6B7280]">Ultima actualizare: {lastUpdated}</div>
        )}
        {intro && <p className="mt-5 text-[#373A45] leading-relaxed">{intro}</p>}

        <div className="mt-10 space-y-8 text-[#373A45] leading-relaxed">{children}</div>

        <div className="mt-16 flex flex-wrap gap-3 text-sm">
          <Link to="/politica-confidentialitate" className="rounded-full px-4 py-1.5 border border-[#E5E7EB] hover:border-[#965EA7] hover:text-[#965EA7]">Politica de confidențialitate</Link>
          <Link to="/politica-cookies" className="rounded-full px-4 py-1.5 border border-[#E5E7EB] hover:border-[#965EA7] hover:text-[#965EA7]">Politica de cookies</Link>
          <Link to="/termeni-conditii" className="rounded-full px-4 py-1.5 border border-[#E5E7EB] hover:border-[#965EA7] hover:text-[#965EA7]">Termeni și condiții</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export function H2({ children }) {
  return <h2 className="font-display text-2xl md:text-3xl font-bold text-[#373A45] mt-10 mb-4">{children}</h2>;
}
export function H3({ children }) {
  return <h3 className="font-display text-lg md:text-xl font-semibold text-[#373A45] mt-6 mb-2">{children}</h3>;
}
export function P({ children }) {
  return <p className="text-[#373A45]/90 leading-relaxed">{children}</p>;
}
export function UL({ children }) {
  return <ul className="list-disc pl-6 space-y-2 text-[#373A45]/90">{children}</ul>;
}
